import waitFor from 'p-wait-for';

import { GtmEvents } from '../../index';
import { pushToDataLayer } from '../gtm/gtm';
import { i18n } from '../locales/schema';

export class GoogleAuth {
  clientId: string;
  uiState: any;

  constructor(clientId: string, uiState: any) {
    this.clientId = clientId;
    this.uiState = uiState;
  }

  createScriptTag(loginCallback: (response: any) => void) {
    const script = document.createElement('script');
    script.id = GoogleAuth.scriptId;
    script.src = GoogleAuth.scriptSrc;
    script.defer = true;
    script.async = true;
    script.onload = () => {
      (window as any).onGoogleLibraryLoad = async () => {
        const google = (window as any).google;
        google.accounts.id.initialize({
          client_id: this.clientId,
          ux_mode: 'popup',
          cancel_on_tap_outside: true,
          context: 'signin',
          callback: loginCallback,
        });

        await new Promise((r) => setTimeout(r, 100));
        this.renderGoogleButton();
      };
    };
    return script;
  }

  clickHandler() {
    // Any changes made to GtmEvents config without updating the GTM configuration may result in tags not firing correctly
    pushToDataLayer(GtmEvents.LoginButtonClick.google);
  }

  async renderGoogleButton() {
    this.uiState.googleLoginLoading = true;

    await waitFor(() => !!(window as any).google);
    if ((window as any).google && !this.uiState.googleLoginButton?.childElementCount && this.uiState.googleLoginButton) {
      await (window as any).google.accounts.id.renderButton(this.uiState.googleLoginButton, {
        theme: 'outline',
        size: 'large',
        type: 'standard',
        text: 'continue_with',
        shape: 'rectangular',
        logo_alignment: 'left',
        locale: i18n.global.locale.value,
        width: this.uiState.googleLoginButton.clientWidth,
        click_listener: this.clickHandler,
      });
    }

    this.uiState.googleLoginLoading = false;
  }

  static get scriptSrc() {
    return 'https://accounts.google.com/gsi/client';
  }

  static get scriptId() {
    return 'google-login-sdk';
  }

  static get buttonId() {
    return 'googleLogin';
  }
}
